import { SearchConditionLabelResponse } from '@doda/api-client/aspida/@types';
import { LOADING_STATUS } from '@doda/common/src/constants/loadingStatus';
import { FetchBaseStateType } from '@doda/common/src/interfaces/fetchBaseState';
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchSearchLabel,
  fetchSaveSearchesSearchLabel,
} from './services/fetchLabel';

/**
 * 検索ラベルの状態を表す型
 */
type SearchLabelState = FetchBaseStateType<SearchConditionLabelResponse | null>;

/**
 * 初期状態
 */
export interface SearchLabelSliceState {
  searchLabel: ReturnType<typeof searchLabelReducer>;
}

export const searchLabelInitialState: SearchLabelState = {
  loading: LOADING_STATUS.IDLE,
  entity: null,
};

/**
 * 検索ラベルのスライスを作成
 */
const searchLabelSlice = createSlice({
  name: 'searchLabel',
  initialState: searchLabelInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSearchLabel.pending, (state) => {
      state.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(fetchSearchLabel.fulfilled, (state, action) => {
      state.loading = LOADING_STATUS.SUCCESS;
      state.entity = action.payload;
    });
    builder.addCase(fetchSearchLabel.rejected, (state) => {
      state.loading = LOADING_STATUS.ERROR;
    });
    builder.addCase(fetchSaveSearchesSearchLabel.pending, (state) => {
      state.loading = LOADING_STATUS.PENDING;
    });
    builder.addCase(fetchSaveSearchesSearchLabel.fulfilled, (state, action) => {
      state.loading = LOADING_STATUS.SUCCESS;
      state.entity = action.payload;
    });
    builder.addCase(fetchSaveSearchesSearchLabel.rejected, (state) => {
      state.loading = LOADING_STATUS.ERROR;
    });
  },
});

/**
 * searchLabelSliceのリデューサ
 */
export const searchLabelReducer = searchLabelSlice.reducer;

interface State {
  searchLabel: SearchLabelState;
}

/**
 * searchLabelEntitySelector
 * @param state
 * @returns 検索条件ラベルレスポンス
 */
export const searchLabelEntitySelector = <S extends State>(state: S) =>
  state.searchLabel.entity;

/**
 * labelTextSelector
 * @param state
 * @returns 検索条件ラベルテキスト
 */
export const labelTextSelector = <S extends State>(state: S) =>
  state.searchLabel.entity?.summary;

/**
 * transitionUrlSelector
 * @param state
 * @returns 検索条件ラベルURL
 */
export const transitionUrlSelector = <S extends State>(state: S) =>
  state.searchLabel.entity?.transitionUrl;
